module.exports = __webpack_public_path__ + "assets/img/11_804_big.5f9871c3.jpg";